// removed by extract-text-webpack-plugin
module.exports = {"wrapper-magazine-thumbnail":"magazines_mRTLD","wrapper-magazine-thumbnail-content":"magazines_w8wZ7","wrapper-magazine-thumbnail-buttons":"magazines_2Qmpi"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Dashboard/components/MagazineThumbnail/styles.scss
// module id = 1042
// module chunks = 1